import React from "react";
import NumberFormat from "react-number-format";
import "./JastipScreen.css";
import Scaffold from "../../CommonComponents/UI/Scaffold/Scaffold";
import UniqueRequestWidget from "./UniqueRequestWidget";
import ViewController from "../../CommonComponents/Base/ViewController";
import JastipViewModel from "./JastipViewModel";
import ProductSummaryItemCellWidget from "../../CommonComponents/UI/Cells/ProductSummaryItemCellWidget";
import KalkulatorWidget from "./Widgets/KalkulatorWidget";
import bag from "./assets/bag_2.png";
import hat from "./assets/hat_2.png";
import shoes from "./assets/shoes_2.png";
import { standarizeThefepiLink } from "../../CommonComponents/Utils";
import mixpanel from "mixpanel-browser";
import { isResellerDomain } from "../../CommonComponents/Utils";
import { mixpanelManager } from "../../Analytics/Mixpanel/Common";

class JastipScreen extends ViewController {
  renderBg1() {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(90deg, #E9CEF1 20.86%, #FED0DA 57.36%, #F7DDEA 92.02%)",
        }}
      />
    );
  }

  renderBg2() {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(89.35deg, #D3BFFC 10.11%, #EDD1F9 52.03%, #D3BFFC 104.29%)",
        }}
      />
    );
  }

  renderBg3() {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(87.49deg, #BEC7FF 9.8%, #CFF8EF 65.39%, #E8E2FC 94.08%)",
        }}
      />
    );
  }

  constructor(props) {
    super(props, new JastipViewModel());
    // idk why the fuck when render is called the viewModel property always undefined, even though its initialized in constructor,
    // probably because nested viewcontroller? who knows
    // temporary workaround
    this.__vm = new JastipViewModel();
    this.__vm.emit = (x) => {
      x();
      this.setState({});
    };
    this.__vm.loadJastipProducts();
    this.state = { won: "" };
    this.state = { idr: "" };
    //     Harga ini sudah termasuk pajak bea cukai dan biaya shipping dari Korea ke Jakarta
    // Untuk produk yang ringan (seperti anting-anting, kalung, scarf, dll) atau produk dari partner brand kami, kami bisa memberikan harga yang lebih murah
    // Harga dapat berubah tergantung pada berat, nilai tukar, dan lainnya.
    // Harga yang tertera di atas hanyalah perkiraan, fixed price dapat diperoleh dari CS kami.
    this.handleChange = this.handleChange.bind(this);
    this.disclaimers = [
      {
        text: "Harga ini sudah termasuk pajak bea cukai dan biaya shipping dari Korea ke Jakarta",
      },
      {
        text: "Untuk produk yang ringan (seperti anting-anting, kalung, scarf, dll) atau produk dari partner brand kami, kami bisa memberikan harga yang lebih murah",
      },
      {
        text: "Harga dapat berubah tergantung pada berat, nilai tukar, dan lainnya.",
      },
      {
        text: "Harga yang tertera di atas hanyalah perkiraan, fixed price dapat diperoleh dari CS kami.",
      },
    ];
    this.advantages = [
      {
        title: "Lebih dari 5 tahun melayani JASTIP",
        renderIcon: () => (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M23 20.5556C23 21.9055 21.9055 23 20.5556 23H3.44444C2.0945 23 1 21.9055 1 20.5556V3.44444C1 2.0945 2.0945 1 3.44444 1H20.5556C21.9055 1 23 2.0945 23 3.44444V20.5556Z"
              stroke="#894CF5"
              stroke-linejoin="round"
            />
            <path
              d="M11.0156 9.85438C11.4703 9.75966 11.9635 9.66493 12.4371 9.66493C14.73 9.66493 16.3592 11.4842 16.3592 13.7007C16.3592 16.865 14.6169 18.9495 11.3383 18.9495C9.1326 18.9495 7.1612 18.0775 7.1612 16.4104C7.1612 15.7094 7.7572 15.1228 8.45814 15.1228C9.21592 15.1228 10.1259 16.3352 11.3951 16.3352C12.7213 16.3352 13.4045 15.0464 13.4045 13.8529C13.4045 12.7162 12.7598 11.9395 11.5852 11.9395C10.4858 11.9395 10.3153 12.5647 9.34914 12.5647C8.61031 12.5647 8.23142 11.163 8.23142 11.6743C8.23142 11.428 8.26931 11.2385 8.28826 11.0302L8.76126 7.03105C8.96964 5.55338 9.32959 5.23132 10.2389 5.23132H14.8051C15.6778 5.23132 16.1887 5.74282 16.1887 6.42482C16.1887 7.7326 15.2042 7.84627 14.8626 7.84627H11.3004L11.0156 9.85438Z"
              stroke="#894CF5"
              stroke-linejoin="round"
            />
          </svg>
        ),
        renderBackground: this.renderBg1,
      },
      {
        title: "Spesialisasi custom clearance service",
        renderIcon: () => (
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.5 11C21.5 16.7989 16.7989 21.5 11 21.5C5.20109 21.5 0.5 16.7989 0.5 11C0.5 5.20109 5.20109 0.5 11 0.5C16.7989 0.5 21.5 5.20109 21.5 11Z"
              stroke="#894CF5"
            />
            <path
              d="M5.00288 12.7659C5.10692 12.611 5.26464 12.6863 5.40455 12.7132C7.23152 13.0684 8.7376 13.3334 10.196 13.3334C13.2617 13.3334 14.7678 13.0683 16.595 12.7131C16.7344 12.686 16.8921 12.6988 16.162 12.7656C17.0659 12.8103 17.2218 12.9489 17.2218 13.4445C17.2218 14.4866 16.6122 15.7356 15.4943 16.7391C14.3871 17.7329 12.8233 18.4445 10.196 18.4445C9.1755 18.4445 7.61168 17.7329 6.50466 16.7391C5.38684 15.7356 4.77734 14.4866 4.77734 13.4445C4.77734 12.9489 4.93322 12.8106 5.00288 12.7659Z"
              stroke="#894CF5"
            />
            <path
              d="M7.27124 6.12118L7.017 5.79768L5.91985 3.57263L5.91984 3.5726C5.88861 3.51371 5.83291 3.49388 5.78968 3.50175L5.70007 3.00985M7.27124 6.12118L9.53653 10.3932C9.57084 10.4582 9.5587 10.5378 9.51477 10.5862L9.84211 10.8833L9.51477 10.5862C9.47493 10.6301 9.42082 10.6375 9.37663 10.6159C9.37655 10.6159 9.37647 10.6158 9.37639 10.6158L7.09886 9.49384L6.7689 9.3313L6.51549 9.5979L4.74496 11.4606C4.74494 11.4607 4.74491 11.4607 4.74488 11.4607C4.71833 11.4886 4.68667 11.5 4.65787 11.5C4.64038 11.5 4.62335 11.4962 4.60641 11.4874C4.55759 11.4615 4.51816 11.3967 4.52969 11.3194L4.9068 8.80217L4.96092 8.44094L4.63324 8.27955L2.58146 7.26896C2.58141 7.26893 2.58136 7.26891 2.58131 7.26888C2.53239 7.24466 2.49136 7.18136 2.50152 7.10349C2.5117 7.02549 2.56552 6.98216 2.6102 6.97402L2.61052 6.97396L4.90064 6.5549L5.25223 6.49057L5.30513 6.13708L5.68077 3.62743L5.1959 3.55486L5.68077 3.62743C5.69193 3.55289 5.74417 3.51008 5.79012 3.50167L5.70007 3.00985M7.27124 6.12118L7.63144 6.05527L9.92079 5.63635C9.92087 5.63634 9.92094 5.63633 9.92101 5.63631C9.96461 5.62851 10.0222 5.64923 10.0534 5.7101C10.0868 5.77705 10.0721 5.85667 10.028 5.90312L10.0279 5.90321L8.43205 7.58154L8.18407 7.84234L8.35265 8.16029L9.53642 10.393L7.27124 6.12118ZM5.70007 3.00985C5.96427 2.96171 6.2315 3.09303 6.36159 3.3384L7.54144 5.56344L5.18628 3.55342C5.22762 3.27719 5.43435 3.0585 5.70007 3.00985ZM14.3692 6.05527L14.7294 6.12118L14.9009 5.79768L16.0808 3.57263L16.0808 3.5726C16.1119 3.51385 16.1675 3.49396 16.2107 3.5017C16.256 3.51016 16.3082 3.55286 16.3194 3.62743L16.695 6.13708L16.7479 6.49057L17.015 6.5549L19.3896 6.97396L19.3901 6.97405C19.436 6.9824 19.4886 7.02566 19.4985 7.1021C19.5087 7.18124 19.4672 7.24435 19.4189 7.2683C19.4188 7.26835 19.4188 7.26839 19.4187 7.26843L17.3669 8.27903L17.0392 8.44042L17.0933 8.80165L17.4704 11.3189C17.4704 11.3189 17.4705 11.319 17.4705 11.3191C17.4705 11.3191 17.4705 11.3191 17.4705 11.3191C17.4819 11.3963 17.4425 11.4609 17.3937 11.4869C17.3768 11.4956 17.3598 11.415 17.3423 11.415C17.3134 11.415 17.2817 11.488 17.2552 11.4601L15.4846 9.59738L15.2312 9.33078L14.9013 9.49332L12.6237 10.6153C12.6237 10.6153 12.6236 10.6154 12.6235 10.6154C12.5793 10.637 12.5252 10.6296 12.4854 10.5857C12.4414 10.5373 12.4293 10.4577 12.4636 10.3927C12.4636 10.3927 12.4636 10.3927 12.4636 10.3927C12.4636 10.3926 12.4637 10.3925 12.4637 10.3924L13.6475 8.16033L13.8161 7.84237L13.5681 7.58154L11.9723 5.90321L11.9722 5.90312C11.9281 5.85677 11.9134 5.77737 11.9465 5.7105C11.9784 5.64902 12.0363 5.62854 12.0796 5.63632C12.0797 5.63633 12.0798 5.63634 12.0798 5.63635L14.3692 6.05527Z"
              stroke="#894CF5"
            />
          </svg>
        ),
        renderBackground: this.renderBg2,
      },
      {
        title: "Memberikan harga terbaik",
        renderIcon: () => (
          <svg
            width="22"
            height="23"
            viewBox="0 0 22 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.0714 6.64603C21.0714 9.75371 18.4917 12.2921 15.2857 12.2921C12.0797 12.2921 9.5 9.75371 9.5 6.64603C9.5 3.53835 12.0797 1 15.2857 1C18.4917 1 21.0714 3.53835 21.0714 6.64603Z"
              stroke="#894CF5"
            />
            <path
              d="M15.335 4.34521V4.45088C15.3267 4.45093 15.3183 4.45101 15.31 4.45113V4.35751V4.07351C15.3138 4.07319 15.318 4.073 15.3225 4.073C15.327 4.073 15.3312 4.07318 15.335 4.07351V4.34521ZM16.8498 4.9059C16.8498 4.90591 16.8494 4.90603 16.8486 4.90623L16.8498 4.9059ZM13.665 7.96573C13.665 7.96573 13.6658 7.96673 13.6671 7.96873C13.6655 7.96672 13.6649 7.96572 13.665 7.96573ZM15.3105 8.97529L15.3308 8.91045L15.3356 8.94493V9.21847C15.3318 9.21881 15.3276 9.21901 15.3232 9.21903C15.3187 9.21902 15.3144 9.21881 15.3105 9.21847V8.97529Z"
              stroke="#894CF5"
            />
            <path
              d="M19.9048 17.8783C20.317 17.8783 20.7872 18.0307 21.1012 18.326C21.2761 18.5617 21.4019 18.827 21.4614 19.0919L13.5983 21.9751L6.78571 20.0719V11.7323H8.18856L15.7472 14.4658C16.101 14.6095 16.2619 14.8546 16.2619 15.1248C16.2619 15.3296 16.1906 15.4962 16.0981 15.5868C16.0449 15.6388 15.9407 15.7111 15.8098 15.7702C15.6765 15.8304 15.5658 15.854 15.5048 15.854H12.6633L10.8634 15.1696L10.3795 14.9856L10.2125 15.4756L9.89817 16.3975L9.74129 16.8577L10.1969 17.0274L12.3969 17.8469L12.4813 17.8783H12.5714H19.9048ZM0.5 11.7323H3.69048V22H0.5V11.7323Z"
              stroke="#894CF5"
            />
          </svg>
        ),
        renderBackground: this.renderBg1,
      },
      {
        title: "Tanpa biaya tambahan",
        renderIcon: () => (
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.5 19.5556C21.5 20.6294 20.6294 21.5 19.5556 21.5H2.44444C1.37064 21.5 0.5 20.6294 0.5 19.5556V2.44444C0.5 1.37064 1.37064 0.5 2.44444 0.5H19.5556C20.6294 0.5 21.5 1.37064 21.5 2.44444V19.5556Z"
              stroke="#894CF5"
            />
            <path
              d="M17.6211 4.30745L17.6208 4.30724C17.1466 3.1919 16.5101 4.13334 16.113 4.61C16.112 4.61018 16.111 4.61037 16.11 4.61055L9.54686 14.8637L9.22379 15.3617L8.78796 14.9587L5.71468 12.117L5.7146 12.1169C5.29791 11.7315 4.6475 11.7572 4.26218 12.1737L17.6211 4.30745ZM17.6211 4.30745C18.097 4.61605 18.2329 5.25248 17.924 5.72927M17.6211 4.30745L17.924 5.72927M17.924 5.72927L17.9237 5.72965L17.9227 5.73121L17.9187 5.73744L17.9027 5.76203L17.8405 5.85798L17.6042 6.22244L16.759 7.52565L14.1807 11.5012C12.2975 14.4049 10.3911 17.3437 10.287 17.5025C10.0527 17.8575 9.70167 17.9733 9.42196 17.9733C9.17239 17.9733 8.92252 17.883 8.72545 17.7003L8.72498 17.618L4.31948 13.6262L4.31936 13.6261C3.90268 13.241 3.8761 12.5907 4.26213 12.1737L17.924 5.72927Z"
              stroke="#894CF5"
            />
          </svg>
        ),
        renderBackground: this.renderBg2,
      },
      {
        title: "Gratis ongkir internasional",
        renderIcon: () => (
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.0697 0.908344L21.0696 0.908397L21.0758 0.914601C21.6431 1.48211 21.6387 2.38873 21.0789 2.93932L21.0758 2.94233L16.0601 7.96022L15.8643 8.15612L15.9266 8.42603L18.5981 20.0118L17.4561 21.1624L12.7697 12.1843L12.4544 11.5804L11.9728 12.0622L6.94424 17.093L6.76694 17.2704L6.8031 17.5186L7.23091 20.4551L6.4195 21.1796L4.55063 17.6559L4.48119 17.5304L4.35578 17.4608L0.816707 15.4963L1.54536 14.7535L4.51695 15.1935L4.7659 15.2304L4.94381 15.0524L9.9337 10.0603L10.4133 9.58046L9.813 9.2644L0.83549 4.53795L1.98746 3.3936L13.5679 6.0662L13.838 6.12854L14.0339 5.93249L19.0496 0.914601L19.0497 0.914656L19.0557 0.908344C19.5812 0.363885 20.5442 0.363886 21.0697 0.908344Z"
              stroke="#894CF5"
            />
          </svg>
        ),
        renderBackground: this.renderBg3,
      },
    ];

    mixpanelManager.trackPageView("Jastip")
  }

  handleChange(event) {
    this.setState({ won: event.target.value });
  }

  getCalc = (event) => {
    if (this.state.won === undefined) {
      this.setState({ idr: 0 });
      return;
    }
    var won = this.state.won.replace(",", "");
    var idr = won.replace(",", "") * 13.5 + 250000;
    this.setState({ idr: idr });
    event.preventDefault();
  };

  resetCalc = (event) => {
    this.setState({ won: "" });
    this.setState({ idr: "" });
  };


  render() {

    return (
      <Scaffold>
        <div style={{paddingTop: this.props.isPromotionBannerActive ? 108 : 0}} className="JastipIntroductionContainer">
          <div
            style={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(109.41deg, #eae3f8 5.81%, #fdf4ff 95.58%)",
            }}
          />

          <img
            src={hat}
            style={{
              height: 80,
              position: "absolute",
              right: "10%",
              bottom: 0,
            }}
          />
          <img
            src={bag}
            style={{
              height: 120,
              position: "absolute",
              top: "2%",
              right: -8,
            }}
          />
          <img
            src={shoes}
            style={{
              height: 120,
              position: "absolute",
              top: "15%",
              left: 0,
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              zIndex: 1,
              position: "relative",
            }}
          >
            <p className="JastipIntroductionHeadline">
              <span style={{ fontWeight: 700 }}>Titip beli</span> apapun yang
              kamu inginkan dari <span style={{ fontWeight: 700 }}>Korea</span>,
              <br />
              <span style={{ fontSize: 14 }}>
                bahkan produk branded limited edition!
              </span>
            </p>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 12,
              marginBottom: 12,
              zIndex: 1,
              position: "relative",
            }}
          >
            <a
            href="#whyus"
              style={{
                color: "#894CF5",
                fontWeight: 900,
                fontSize: "14px",
                textDecoration: 'underline'
              }}
            >
              Mengapa jastip di THE FEPI?
            </a>
          </div>
          <div
            style={{
              zIndex: 1,
              position: "relative",
            }}
          >
            <UniqueRequestWidget
              onRequestClick={(u) => {
                window.location.href = `https://api.whatsapp.com/send?phone=${
                  window.__config.DEFAULT_CS_PHONE_NUMBER
                }&text=${this.__vm.onJastipCustomRequestMessage(u)}`;
              }}
            />
          </div>
        </div>

        <div className="JastipAdvantagesContainer">
        <div id="whyus" style={{position: 'relative', top: -92}} />
          <div className="JastipSectionTitle" >Kelebihan</div>
          {this.advantages.map((a, index) => (
            <div
              style={{
                position: "relative",
                borderRadius: 16,
                overflow: "hidden",
                marginBottom: index === this.advantages.length - 1 ? 0 : 12,
              }}
            >
              <div className="JastipAdvantageListItem" style={{ zIndex: 1 }}>
                <div className="JastipAdvantageListItemIconBackground">
                  {a.renderIcon?.()}
                </div>
                <div className="JastipAdvantageListItemTitle">{a.title}</div>
              </div>
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  zIndex: 0,
                }}
              >
                {a.renderBackground?.()}
              </div>
            </div>
          ))}
        </div>
        <div className="JastipAdvantagesContainer">
          <div className="JastipSectionTitle">Titipan Orang Lain</div>
          <div className="JastipProductsGrid">
            {this.__vm.products.slice(0, 9).map((p) => (
              <ProductSummaryItemCellWidget
                model={p}
                cellWidth={this.state.width / 3 - 24}
              />
            ))}
          </div>
          <div>
            <button
              className="JastipSeeAllButton"
              onClick={() => {
                window.location.href = standarizeThefepiLink("/Store/Products?groupId=jastip");
              }}
            >
              See All
            </button>
          </div>
        </div>
        <KalkulatorWidget
          idr={this.__vm.idr === 0 ? "" : this.__vm.idr}
          won={this.__vm.won}
          onWonChange={(v) => this.__vm.changeWon(v)}
          onConvertClick={() => this.__vm.calculate()}
          onResetClick={() => this.__vm.resetCalculator()}
        />
        <ul className="JastipDisclaimers">
          {this.disclaimers.map((d) => (
            <li>{d.text}</li>
          ))}
        </ul>
        <div className="row">
          <div
            className="col text-center"
            style={{ padding: "0px 32px 0px 32px" }}
          >
            <br></br>
            <br></br>
            <img
              className="img-fluid"
              src={
                global.ImgUrl +
                "shopable/0429C86B-0D54-4463-B594-B2E65288F223.png"
              }
              alt="gambar8"
            ></img>
          </div>
        </div>
        <div className="row ptop30">
          <div className="col text-center">
            <span>.</span>
            <br></br>
            <span>.</span>
            <br></br>
            <span>.</span>
            <p style={{ fontSize: "17px" }}>
              <b>
                dan brand lainnya yang <br></br> kamu inginkan!
              </b>
            </p>
          </div>
        </div>
        <div className="row ptop30">
          <div className="col text-center">
            <br></br>
            <br></br>
            <br></br>
            <h1>😍</h1>
            <h3>
              Stay tune for your fashionable <br></br> life with The Fepi
            </h3>
            <br></br>
          </div>
        </div>
      </Scaffold>
    );
  }
}

export default JastipScreen;
